import Vue from 'vue';
import App from './app/app.vue';
import router from './app/app-routes';

Vue.config.productionTip = false;

Vue.use(require('vue-moment'));

const vue = new Vue({
  router,
  render: (h) => h(App),
});

vue.$mount('#app');
